import styled from 'styled-components';

export const Container = styled.div`
  max-width: 720px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    margin-bottom: 24px;
  }
`;

export const ImportantNoteBox = styled.div`
  margin-top: 12px;
  padding: 16px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(0, 0, 0, 0.03)'};
  border-radius: 8px;
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.08)'};
`;

export const OptionCard = styled.div`
  padding: 16px;
  border-radius: 8px;
  border-left: 4px solid ${(props) => props.color};
  background: ${(props) => {
    if (props.theme.name === 'dark') {
      if (props.color === '#fa4616') return 'rgba(250, 70, 22, 0.05)';
      if (props.color === '#22c55e')
        return props.theme?.colors?.success
          ? `${props.theme.colors.success}0D`
          : 'rgba(34, 197, 94, 0.05)';
      return 'rgba(34, 197, 94, 0.05)';
    } else {
      if (props.color === '#fa4616') return 'rgba(250, 70, 22, 0.03)';
      if (props.color === '#22c55e')
        return props.theme?.colors?.success
          ? `${props.theme.colors.success}08`
          : 'rgba(34, 197, 94, 0.03)';
      return 'rgba(34, 197, 94, 0.03)';
    }
  }};
`;

export const OptionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) =>
    props.color === '#22c55e'
      ? props.theme?.colors?.success || '#22c55e'
      : props.color};
  margin: 0 0 8px 0;
`;

export const OptionDescription = styled.p`
  font-size: 13px;
  line-height: 1.5;
  color: ${(props) => (props.theme.name === 'dark' ? '#e2e8f0' : '#475569')};
  margin: 0 0 12px 0;
`;

export const OptionList = styled.ul`
  list-style: none;
  font-size: 12px;
  color: ${(props) => (props.theme.name === 'dark' ? '#cbd5e1' : '#64748b')};
  margin: 0;
  padding: 0;
`;

export const OptionListItem = styled.li`
  padding: 4px 0 4px 16px;
  position: relative;

  &:before {
    content: '•';
    position: absolute;
    left: 4px;
    color: ${(props) => (props.theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  }
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#fff' : props.theme.colors.blueBlack};
  margin: 0;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const MethodCards = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 40px;

  @media (max-width: 768px) {
    gap: 12px;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

export const MethodCard = styled.div`
  padding: 28px;
  background: ${(props) =>
    props.selected
      ? 'rgba(250, 70, 22, 0.1)'
      : props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : '#f8f9fa'};
  border: 2px solid
    ${(props) =>
      props.selected
        ? '#fa4616'
        : props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0,0,0,0.08)'};
  border-radius: 12px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s;
  text-align: center;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  &:hover {
    border-color: ${(props) =>
      props.disabled
        ? props.theme.name === 'dark'
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(0,0,0,0.08)'
        : props.selected
        ? '#fa4616'
        : 'rgba(250, 70, 22, 0.5)'};
    background: ${(props) =>
      props.disabled
        ? props.theme.name === 'dark'
          ? 'rgba(255, 255, 255, 0.03)'
          : '#f8f9fa'
        : props.selected
        ? 'rgba(250, 70, 22, 0.12)'
        : props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : '#ffffff'};
  }

  @media (max-width: 768px) {
    padding: 20px 16px;
  }

  @media (max-width: 480px) {
    padding: 16px 12px;
  }
`;

export const MethodIcon = styled.svg`
  width: 40px;
  height: 40px;
  color: #fa4616;
  margin-bottom: 16px;

  @media (max-width: 480px) {
    width: 32px;
    height: 32px;
    margin-bottom: 12px;
  }
`;

export const MethodTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack};
  margin-bottom: 8px;

  @media (max-width: 480px) {
    font-size: 16px;
    margin-bottom: 6px;
  }
`;

export const MethodDesc = styled.div`
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#94a3b8;' : '#64748B')};
  line-height: 1.4;
  margin-bottom: 6px;

  @media (max-width: 480px) {
    font-size: 12px;
    margin-bottom: 4px;
  }
`;

export const MethodHighlight = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) =>
    props.invalidate ? '#ef4444' : props.theme?.colors?.success || '#22c55e'};

  @media (max-width: 480px) {
    font-size: 12px;
  }
`;

export const TicketSectionContainer = styled.div`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(0, 0, 0, 0.02)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.08)'};
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const TicketSectionTitle = styled.h3`
  font-size: 13px;
  color: ${(props) => (props.theme.name === 'dark' ? '#CBD5E1' : '#94A3B8')};
  margin-bottom: 16px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.8px;
`;

export const TicketList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TicketItem = styled.div`
  display: flex;
  align-items: center;
  padding: 18px 20px;
  background: ${(props) =>
    props.selected
      ? 'rgba(250, 70, 22, 0.1)'
      : props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : '#ffffff'};
  border: 2px solid
    ${(props) =>
      props.selected
        ? '#fa4616'
        : props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0,0,0,0.08)'};
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${(props) =>
      props.selected
        ? 'rgba(250, 70, 22, 0.15)'
        : props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : '#f8f9fa'};
    border-color: ${(props) =>
      props.selected ? '#fa4616' : 'rgba(250, 70, 22, 0.3)'};
  }

  @media (max-width: 768px) {
    padding: 14px 16px;
  }
`;

export const SelectionCircle = styled.div`
  width: 22px;
  height: 22px;
  border: 2px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.2)'
        : 'rgba(0,0,0,0.2)'};
  border-radius: 50%;
  margin-right: 16px;
  flex-shrink: 0;
  position: relative;
  background: ${(props) => (props.selected ? '#fa4616' : 'transparent')};
  transition: all 0.2s;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    background: white;
    border-radius: 50%;
    opacity: ${(props) => (props.selected ? 1 : 0)};
    transition: opacity 0.2s;
  }
`;

export const TicketInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0; /* Allow text to wrap */
`;

export const TicketName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack};
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const TicketSerialRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  margin-top: 5px;
`;

export const SerialNumber = styled.span`
  font-size: 17px;
  color: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255,255,255,0.6)' : '#64748B'};
  font-weight: 500;
`;

export const SerialSuffix = styled.span`
  font-size: 14px;
  color: #ffffff;
  font-weight: 700;
  background: #475569;
  padding: 2px 8px;
  border-radius: 4px;
`;

export const TicketPrice = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => props.theme?.colors?.success || '#22c55e'};
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ProcessingFeesSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
  background: transparent;
  margin-bottom: 24px;
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const ProcessingFeesLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const Checkbox = styled.div`
  width: 22px;
  height: 22px;
  border: 2px solid #fa4616;
  border-radius: 4px;
  background: ${(props) => (props.checked ? '#fa4616' : 'transparent')};
  position: relative;
  flex-shrink: 0;
  transition: all 0.2s;

  ${(props) =>
    props.checked &&
    `
    &:after {
      content: '';
      position: absolute;
      top: 2px;
      left: 6px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  `}
`;

export const ProcessingFeesText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ProcessingFeesTitle = styled.div`
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack};
  font-size: 15px;
  font-weight: 600;
`;

export const ProcessingFeesDesc = styled.div`
  color: ${(props) => (props.theme.name === 'dark' ? '#CBD5E1' : '#94A3B8')};
  font-size: 13px;
`;

export const ProcessingFeesAmount = styled.span`
  font-size: 18px;
  color: ${(props) => props.theme?.colors?.success || '#22c55e'};
  font-weight: 700;
`;

export const ProcessingFeesRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const TotalRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 12px;
  margin-top: 12px;
  border-top: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'};
`;

export const CustomAmountSection = styled.div`
  padding: 24px;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(30, 32, 44, 0.7)' : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.05)'
        : 'rgba(0,0,0,0.08)'};
  border-radius: 12px;
  margin-bottom: 32px;

  ${TicketSectionTitle} {
    color: ${(props) => (props.theme.name === 'dark' ? '#CBD5E1' : '#64748B')};
  }

  @media (max-width: 768px) {
    padding: 16px;
    margin-bottom: 24px;
  }
`;

export const InfoBanner = styled.div`
  background: ${(props) =>
    props.theme?.colors?.success
      ? `${props.theme.colors.success}1A`
      : 'rgba(34, 197, 94, 0.1)'};
  border: 1px solid
    ${(props) =>
      props.theme?.colors?.success
        ? `${props.theme.colors.success}33`
        : 'rgba(34, 197, 94, 0.2)'};
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${(props) => props.theme?.colors?.success || '#22c55e'};
  font-size: 13px;
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const DollarSign = styled.span`
  position: absolute;
  left: 18px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: ${(props) => (props.theme.name === 'dark' ? '#64748B' : '#94A3B8')};
`;

export const AmountInput = styled.input`
  width: 100%;
  padding: 14px 18px 14px 44px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255,255,255,0.05)'
      : 'rgba(0,0,0,0.02)'};
  border: 2px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.08)'
        : 'rgba(0,0,0,0.1)'};
  border-radius: 8px;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack};
  font-size: 20px;
  font-weight: 600;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: #fa4616;
    background: ${(props) =>
      props.theme.name === 'dark' ? 'rgba(255,255,255,0.08)' : '#ffffff'};
  }

  &::placeholder {
    color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#94A3B8')};
  }
`;

export const OriginalAmount = styled.div`
  margin-top: 10px;
  font-size: 13px;
  color: ${(props) => (props.theme.name === 'dark' ? '#CBD5E1' : '#64748B')};
`;

export const CreditTotalLabel = styled.div`
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
  text-transform: none;
  font-weight: 400;
`;

export const CreditTotalAmount = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #fa4616;
`;

// Modal styled components
export const ModalContent = styled.div`
  padding: 32px;
`;

export const ModalHeader = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

export const ModalIconWrapper = styled.div`
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #fa4616 0%, #ff6b47 100%);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  box-shadow: 0 8px 24px rgba(250, 70, 22, 0.3);
`;

export const ModalIcon = styled.svg`
  width: 36px;
  height: 36px;
  color: white;
`;

export const ModalTitle = styled.h2`
  font-size: 22px;
  color: ${(props) =>
    props.theme?.name === 'dark'
      ? props.theme?.colors?.textGray?.primary || '#ffffff'
      : props.theme?.colors?.blueBlack || '#0F172A'};
  margin-bottom: 8px;
`;

export const ModalSubtitle = styled.p`
  font-size: 14px;
  color: ${(props) =>
    props.theme?.name === 'dark'
      ? props.theme?.colors?.textGray?.secondary || '#94A3B8'
      : '#64748B'};
`;

export const ModalBreakdown = styled.div`
  margin: 24px 0;
`;

export const ModalBreakdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: ${(props) => (props.single ? '20px' : '16px')};
  background: ${(props) =>
    props.theme?.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(0, 0, 0, 0.02)'};
  border-radius: ${(props) => (props.single ? '12px' : '10px')};
  margin-bottom: ${(props) => (props.single ? '0' : '12px')};
  border: 1px solid
    ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.08)'};
  border-left: ${(props) =>
    props.single
      ? props.theme?.name === 'dark'
        ? '1px solid rgba(255, 255, 255, 0.08)'
        : '1px solid rgba(0, 0, 0, 0.08)'
      : props.type === 'credit'
      ? '4px solid #fa4616'
      : '4px solid #22c55e'};
  transition: all 0.2s;

  &:hover {
    background: ${(props) =>
      props.theme?.name === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.04)'};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ModalBreakdownIcon = styled.div`
  width: ${(props) => (props.large ? '52px' : '44px')};
  height: ${(props) => (props.large ? '52px' : '44px')};
  border-radius: ${(props) => (props.large ? '12px' : '10px')};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${(props) =>
    props.type === 'credit'
      ? 'rgba(250, 70, 22, 0.15)'
      : 'rgba(34, 197, 94, 0.15)'};
  color: ${(props) => (props.type === 'credit' ? '#fa4616' : '#22c55e')};
`;

export const ModalBreakdownInfo = styled.div`
  flex: 1;
`;

export const ModalBreakdownLabel = styled.div`
  font-size: 13px;
  color: ${(props) =>
    props.theme?.name === 'dark'
      ? props.theme?.colors?.textGray?.secondary || '#94A3B8'
      : '#64748B'};
  margin-bottom: 4px;
  text-transform: ${(props) => (props.uppercase ? 'uppercase' : 'none')};
  letter-spacing: ${(props) => (props.uppercase ? '0.5px' : '0')};
`;

export const ModalBreakdownTitle = styled.div`
  font-size: ${(props) => (props.large ? '16px' : '15px')};
  color: ${(props) =>
    props.theme?.name === 'dark'
      ? props.theme?.colors?.textGray?.primary || '#ffffff'
      : props.theme?.colors?.blueBlack || '#0F172A'};
  font-weight: 600;
  margin-bottom: ${(props) => (props.hasDescription ? '4px' : '0')};
`;

export const ModalBreakdownDescription = styled.div`
  font-size: 13px;
  color: ${(props) =>
    props.theme?.name === 'dark'
      ? props.theme?.colors?.textGray?.dark || '#e2e8f0'
      : '#64748B'};
  line-height: 1.5;
`;

export const ModalBreakdownAmount = styled.div`
  font-size: ${(props) => (props.large ? '28px' : '22px')};
  font-weight: 700;
  color: ${(props) => (props.type === 'credit' ? '#fa4616' : '#22c55e')};
  flex-shrink: 0;
`;

export const ModalDivider = styled.div`
  height: 1px;
  background: ${(props) =>
    props.theme?.name === 'dark'
      ? 'rgba(255, 255, 255, 0.1)'
      : 'rgba(0, 0, 0, 0.1)'};
  margin: 20px 0;
`;

export const ModalTotal = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: rgba(250, 70, 22, 0.08);
  border-radius: 10px;
`;

export const ModalTotalLabel = styled.span`
  font-size: 15px;
  color: ${(props) =>
    props.theme?.name === 'dark'
      ? props.theme?.colors?.textGray?.dark || '#e2e8f0'
      : '#64748B'};
  font-weight: 600;
`;

export const ModalTotalAmount = styled.span`
  font-size: 26px;
  font-weight: 700;
  color: #fa4616;
`;

export const ModalButtonWrapper = styled.div`
  margin-top: 24px;
  width: 100%;
`;
